<template>
  <div class="critical-error-container">
    <div class="error-box">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" class="error-icon" viewBox="0 0 16 16">
        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
      </svg>
      <h2>Serviço Temporariamente Suspenso</h2>
      <p class="main-message">
        O nosso parceiro para pagamentos remotos enfrenta problemas técnicos e suspendemos as operações.
      </p>
      <p class="sub-text">
        Agradecemos a sua compreensão. Por favor, tente novamente mais tarde.
      </p>
    </div>
  </div>

  <div v-if="false">
    <div class="title-bar" style="margin-bottom: 0px"><h2 class="dz-title">Os mais procurados</h2></div>
    <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false"
         class="swiper swiper-init main-swiper mb-40 overlay-swiper1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="prod in prodProList" :key="prod.id">
          <div class="card-overlay style-1 bg-primary"
               style="height: 16.5em; display: flex; flex-wrap: wrap; align-content: center;"
               @click="addToCart(`${ prod.id }`, $event)">
            <div class="dz-media">
              <div class="img-container">
                <img
                    :src="getProductImage(prod)"
                    class="product-img"
                    alt=""
                    @load="onImgLoad"
                />
              </div>
            </div>
            <div class="dz-info">
              <h5 class="item-title title"><a href="/item-details/">{{ prod.title }}</a></h5>
              <div class="dz-meta" style="width: 180px">
                <ul style="justify-content: space-between">
                  <li class="price">{{ prod.price }}<sup>€</sup></li>
                  <li class="mt-5"><img style="width: 24px; height: 24px" :src="`${ allergen }`" v-for="allergen in prod.alergenio_image"
                                        :key="allergen.id"/></li>
                </ul>
              </div>
              <div class="dz-meta">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="title-bar">
      <h4 class="dz-title">Categorias</h4>
    </div>
    <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false"
         class="swiper swiper-init mb-40 main-swiper categories-swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in categoriesList" :key="item.id">
          <a @click="toggleCategoryId(`${ item.id }`)">
            <div class="categories-bx" style="align-items: center;">
              <div class="dz-content">
                <h5 class="title"><a href="/" @click="toggleCategoryId(`${ item.id }`)">{{
                    item.title
                  }}</a></h5>
                <span class="menus text-primary">{{ getTotalText(item.total) }}</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <PromoBar v-if="promoList.length > 0" :promoList="promoList"></PromoBar>
  </div>
</template>

<script>
import axios from "axios";
import Swiper from "swiper";
import PromoBar from "@/components/PromoBar";

export default {
  name: 'MainPage',
  components: {PromoBar},
  props: ['prodProList', 'categoriesList', 'categoryId', 'promoList'],
  emits: ['toggle-category-products'],

  async mounted() {
    this.clearCache()
    new Swiper('.swiper-init', {
      // Swiper configuration options
      spaceBetween: 20,
      slidesPerView: 'auto',
      centeredSlides: false,
    });
  },

  methods: {
    clearCache() {
      setTimeout(() => {
        localStorage.clear();
      }, 100);
    },

    addToCart(id, event) {
      const card = event.currentTarget;
      card.classList.add('clicked');

      setTimeout(() => {
        card.classList.remove('clicked');
      }, 300);

      this.$store.commit('addToCard', this.prodProList.find(i => i.id === id))
    },
    getTotalText(total) {
      return total > 1 ? `${total} produtos` : `${total} produto`;
    },
    async toggleCategoryId(id) {
      let categoryProductList = {};
      try {
        const category = await this.loadCategory(id);
        const products = await this.loadProducts(id);
        categoryProductList['category'] = category;
        categoryProductList['products'] = products;
        this.$emit('toggle-category-products', categoryProductList);
      } catch (error) {
        console.error(error.message);
      }
    },

    async loadProducts(id) {
      const regex = /[a-zA-Z0-9]/g;
      let productUrl = process.env.VUE_APP_SERVICE_URL + 'products?category=' + id;
      let productUrlRegex = productUrl.match(regex).join('');
      let cachedProductUrl = localStorage.getItem(productUrlRegex);
      if (cachedProductUrl) {
        return JSON.parse(cachedProductUrl);
      } else {
        try {
          const response = await axios.get(productUrl);
          localStorage.setItem(productUrlRegex, JSON.stringify(response.data.products));
          return response.data.products;
        } catch (error) {
          console.error(error.message);
          throw error;
        }
      }
    },

    async loadCategory(id) {
      const regex = /[a-zA-Z0-9]/g;
      let categoryUrl = process.env.VUE_APP_SERVICE_URL + 'category?category=' + id;
      let categoryUrlRegex = categoryUrl.match(regex).join('');
      let cachedCategoryUrl = localStorage.getItem(categoryUrlRegex);
      if (cachedCategoryUrl) {
        return JSON.parse(cachedCategoryUrl);
      } else {
        try {
          const response = await axios.get(categoryUrl, {params: {category: id}});
          localStorage.setItem(categoryUrlRegex, JSON.stringify(response.data[0]));
          return response.data[0];
        } catch (error) {
          console.error(error.message);
          throw error;
        }
      }
    },
    getProductImage(item) {
      if (!item) return '/assets/img/placeholder.png';

      const categoryTitle = item.category ? String(item.category).trim() : '';
      const itemId = String(item.id);

      const folders = {
        "Baguetes": "baguetes/",
        "Tostas": "tostas/",
        "Torradas": "torradas/",
        "Bolos": "bolos/",
        "Bebidas Quentes": "bebidas quentes/",
        "Bebidas Frias": "bebidas frias/",
        "Gelados": "gelados/",
        "Pizzas": "pizzas/",
        "Nuggets": "nuggets/"
      };

      const fileMap = {
        "80": "baguette branca com fiambre.png",
        "81": "baguette branca com queijo.png",
        "82": "baguette branca mista.png",
        "83": "baguette branca com pasta de atum.png",
        "84": "baguette multicereais com pasta de delicias do mar.png",
        "85": "baguette multicereais com fiambre.png",
        "86": "baguette multicereais com queijo.png",
        "87": "baguette multicereais mista.png",
        "88": "baguette multicereais com pasta de atum.png",
        "89": "baguette branca com pasta de delicias do mar.png",
        "90": "baguette sem gluten com queijo.png",
        "91": "baguette sem gluten com fiambre.png",
        "92": "baguette sem gluten mista.png",
        "93": "baguette sem gluten com pasta de atum.png",
        "96": "baguette sem gluten com pasta de delicias do mar.png",

        "32": "tosta de fiambre.png",
        "33": "tosta de queijo.png",
        "34": "tosta mista.png",
        "35": "tosta de pasta de atum.png",
        "36": "tosta de pasta de delicias do mar.png",
        "140": "tosta amendoim compota.png",

        "30": "torrada com compota de abobora.png",
        "31": "torrada com manteiga.png",
        "130": "torrada com compota de frutos vermelhos.png",
        "134": "torrada com creme de barrar de bolachas belgas Lotus Biscoff.png",

        "42": "nata.png",
        "111": "tarte_maçã.png",

        "1": "Café.png", "3": "Café.png", "4": "Café.png", "107": "Café.png", "109": "Café.png",
        "5": "chinesa.png",
        "2": "galão.png",
        "7": "Chá.png", "54": "Chá.png", "55": "Chá.png", "56": "Chá.png", "57": "Chá.png", "58": "Chá.png", "59": "Chá.png",
        "60": "chocolate quente.png",

        "9": "atlantida_semgas_22_final.jpg",
        "10": "Coral_PuroMalte 2019.jpg",
        "11": "Coral_STOUT 20cl_2022.jpg",
        "15": "ucal.png",
        "16": "brisa-maca-0_36Lt-800x800-1.jpg",
        "17": "Brisa Maracuja_36CL 2017.jpg",
        "19": "compal manga cenoura laranja.png",
        "20": "compal pessego.png",
        "21": "compal laranja.png",
        "23": "compal maracuja.png",
        "45": "cerveja pressão.png",
        "48": "Laranjada 33cl.jpg",
        "49": "Brisa-Maracuja-sem-acucar-036.jpg",
        "50": "compal pera.png",
        "51": "c.-frutos-vermelhos-0.2l.png",
        "52": "Atlantida 50 cl_blue .jpg",
        "53": "atlantida_gas_22_final.jpg",
        "61": "fuze-tea-limao-vidro-300ml-produto.jpg",
        "62": "fuze-tea-pessego-vidro-300ml-produto.jpg",
        "63": "fuze-tea-manga-ananas-vidro-300ml-produto.jpg",
        "65": "coca-cola-original-vidro-350ml-gotas.png",
        "68": "coca-cola-zero-acucar-vidro-350ml-gotas.png",
        "69": "fanta-laranja-vidro-350ml.png",
        "70": "fanta-ananas-vidro-350ml-gotas.png",
        "97": "monster.jpg",
        "99": "bandida maça.png",
        "100": "água com limão - castello.png",
        "101": "sprite-vidro-350ml-gotas.png",
        "102": "coca-cola-zero-baunilha-lata-sleek-330ml-gotas.png",
        "103": "monster_energy_ultra-350x350.png",
        "141": "pepsi.jpg",
        "142": "pepsi.jpg",
        "145": "pepsi.jpg",

        "112": "calipo limão.png",
        "113": "perna de pau.png",
        "114": "solero exotic.jpg",
        "115": "cornetto filipino.png",
        "116": "CORNETTO-CLASSIC-VANILLA-600x600.png",
        "117": "cornetto morango.png",
        "118": "filipinos sandwich.png",
        "119": "magnum sandwich.jpg",
        "120": "Magnum Double Gold billionaire.jpg",
        "121": "Magnum chocolate branco.png",
        "122": "Magnum de amêndoas.png",
        "124": "Calippo de morango.jpg",

        "131": "pizza romana.jpg",
        "132": "pizza pepperoni.jpg",
        "133": "pizza margerita.png",
        "135": "pizza estacoes.jpg",

        "138": "DezNuggetsFrango.png",
        "139": "CincoNuggetsFrango.png"
      };

      const folder = folders[categoryTitle];
      const fileName = fileMap[itemId];

      if (folder && fileName) {
        return `/assets/img/products/${folder}${fileName}`;
      }

      return item.image && item.image.length > 5 ? item.image : '/assets/img/placeholder.png';
    },
    onImgLoad(event) {
      const img = event.target;
      const container = img.parentElement;
      const cW = container.clientWidth;
      const cH = container.clientHeight;
      if (img.naturalWidth <= cW && img.naturalHeight <= cH) {
        img.style.width = 'auto';
        img.style.height = 'auto';
      } else {
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
      }
    },
  },
};
</script>

<style>
/* --- ESTILOS DA TUA MENSAGEM DE ERRO --- */
.critical-error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  padding: 20px;
  text-align: center;
}

.error-box {
  background-color: #fffafb;
  border: 2px solid #e00024;
  border-radius: 12px;
  padding: 40px 30px;
  max-width: 500px;
  box-shadow: 0 10px 25px rgba(224, 0, 36, 0.15);
  margin: 0 auto;
}

.error-icon {
  color: #e00024;
  margin-bottom: 20px;
}

.error-box h2 {
  color: #e00024;
  margin-bottom: 15px;
  font-size: 1.5rem;
  font-weight: 700;
}

.main-message {
  color: #333;
  font-size: 1.1rem;
  line-height: 1.5;
  font-weight: 500;
  margin-bottom: 15px;
}

.sub-text {
  font-size: 0.9rem;
  color: #777;
  margin-top: 10px;
}

/* --- OS TEUS ESTILOS ORIGINAIS INTACTOS --- */
.bg-primary {
  background-color: #ffffff !important;
  border: 1px solid #efefef !important;
  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.1) !important;
  color: #000 !important;
  transition: all 0.3s ease !important;
  cursor: pointer !important;
}

.bg-primary:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  border-color: #04764e !important;
}

.bg-primary:active {
  transform: translateY(0) scale(0.98) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.1s ease !important;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.02); }
  100% { transform: scale(1); }
}

.bg-primary.clicked {
  animation: pulse 0.3s ease;
}
.bg-primary * {
  color: #000 !important;
}

.card-overlay { overflow: hidden; }

.dz-media {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

.img-container {
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0 auto;
  background: transparent;
}

.product-img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.bg-primary:hover .product-img {
  transform: scale(1.05);
}

@media (max-width: 600px) {
  .img-container { width: 110px; height: 110px; }
}
</style>